import { Checkbox } from '@material-ui/core';
import * as React from 'react';
import { DSListItem, DSListItemIcon, DSListItemText } from '../../../mui';
import { PickableClientOrLocation } from './types';

export type PickerListItemProps = Pick<React.HTMLAttributes<any>, 'style'> & {
    item: PickableClientOrLocation;
    selected: ReadonlyArray<string>;
    disabled: ReadonlyArray<string>;
    onChange: (selected: string[]) => void;
};

export const PickerListItem: React.FC<PickerListItemProps> = ({ disabled, item, onChange, selected, style }) => {
    const isChecked = selected.includes(item.id);
    const isDisabled = disabled.includes(item.id);
    const remainingCollectionCount = item.maxCollections - item.currentCollections;
    const maxedCollectionCount = remainingCollectionCount <= 0 && !isChecked;
    const displayedCollectionCount = item.currentCollections + (isChecked ? 1 : 0);

    const handleCheck = React.useCallback(() => {
        if (!isChecked) {
            onChange([...selected, item.id]);
        } else {
            onChange(selected.filter(id => id !== item.id));
        }
    }, [isChecked, item.id, onChange, selected]);

    return (
        <DSListItem
            button
            dense
            disabled={isDisabled || maxedCollectionCount}
            key={item.id}
            selected={isChecked}
            style={style}
            onClick={handleCheck}
        >
            <DSListItemIcon>
                <Checkbox
                    checked={isChecked}
                    color="primary"
                    disableRipple
                    edge="start"
                    inputProps={{ 'aria-labelledby': item.title }}
                    tabIndex={-1}
                />
            </DSListItemIcon>
            <DSListItemText
                primary={item.title}
                primaryTypographyProps={{ style: { fontSize: '1rem' } }}
                secondary={`(collections ${displayedCollectionCount}/${item.maxCollections})`}
            >
                {item.title}
            </DSListItemText>
        </DSListItem>
    );
};
